import { React, useContext, useEffect, useRef, useState } from "react";
import { PageContext } from "../../App";
import {
  formatBytes,
  getFileExtension,
  readPDFFile,
  renderPDFPage,
  saveFile,
  readEncryptedPDFFileAsArrayBuffer,
  readPDFFileAsArrayBuffer,
} from "../Utils";
import { StandardFonts } from "pdf-lib-plus-encrypt";
import WatermarkPositions from "../watermark_pdf/WatermarkPositions";
import { HexColorPicker } from "react-colorful";
import { PDFDocument } from "pdf-lib-plus-encrypt";
import { addPageNumbersToPDF } from "../PDFHelper/PDFRenderer";
import PDFViewerView from "../pdf_viewer/PDFViewerView";

function NumberPDFPagesImagesListScreen(props) {
  // AppStatus.ts
  const AppState = {
    LOADED: "LOADED",
    PROCESSING: "PROCESSING",
    PROCESSED: "PROCESSED",
    NONE: "NONE",
  };

  //initialized flaf
  const initializedRef = useRef(false);
  //fileinfo list
  //store thumbnail, page count etc key is filepath
  const [filesInfo, setFilesInfo] = useState({});
  //item displaying in password input modal
  const [selectedItemForPasswordInput, setSelectedItemForPasswordInput] =
    useState(null);
  //password input modal input field reference
  //get password value
  const passwordInputModalInputRef = useRef(null);
  //is numbering
  const [isNumbering, setIsNumbering] = useState(false);
  //additional settings
  //convert grayscale
  //scale resolution
  const [additionalSettings, setAdditionalSettings] = useState({
    font: {
      font: StandardFonts.Courier,
      popupShowing: false,
    },
    font_size: 20,
    position: { position: WatermarkPositions.Bottom, popupShowing: false },
    padding: { x: 0, y: 0 }, //padding in pixels
    color: { color: "#000000", popupShowing: false },
    opacity: {
      opacity: 50,
      popupShowing: false,
    },
    start_from_zero: false,
  });

  //show pdf preview
  const [showPDFPreview, setShowPDFPreview] = useState({
    preview: false,
    file: null,
    password: "",
  });

  //get context
  const {
    selectedFiles,
    setSelectedFiles,
    setShowEditFileScreen,
    setStartProcessingFiles,
  } = useContext(PageContext);

  //start
  useEffect(() => {
    //check
    if (initializedRef.current === false) {
      //set
      initializedRef.current = true;
      //generate thumbnails
      generateThumbnails();

      console.log("Load top loading bar");
    }

    //if selected files list is empty
    //reset screen
    //show upload button
    if (selectedFiles.length === 0) {
      //reset
      resetScreen();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFiles]);

  //generate thumbnails
  const generateThumbnails = async () => {
    //loop
    //read files
    //get thumbnails
    for (let i = 0; i < selectedFiles.length; i++) {
      //process pdf file
      processPDFFile(selectedFiles[i], "");
    }
  };

  //fetch pdf file as data
  //get thumbnail
  //chek if password protected
  //unlock if provided correct password
  //render file
  const processPDFFile = async (selectedFile, password) => {
    //get image
    pdfThumbnail(selectedFile, password);
  };

  //pdf thumbnail
  const pdfThumbnail = async (selectedFile, password) => {
    //read pdf file
    await readPDFFile(selectedFile)
      .then(async (data) => {
        //path pdf file
        const key = String(selectedFile.path);
        //thumbnail
        await renderPDFPage(data, password, "image/jpeg", 0.2, 0)
          .then(([img, numPages]) => {
            //set image
            setFilesInfo((prevDictionary) => ({
              ...prevDictionary,
              [key]: {
                ...filesInfo[key],
                state: AppState.LOADED,
                thumbnail: img,
                pageCount: numPages,
                message:
                  numPages > 100
                    ? "Note: Too many pages in this pdf file. To protect your privacy our app runs entirely offline, so your device must have enough memory available to convert this file successfully."
                    : "",
                locked: false,
                password: password,
                name: selectedFile.name,
                file: selectedFile, //selected file
                size: selectedFile.size, //in bytes
                number_pages_blob: null,
                number_pages_size: 0,
              },
            }));
          })
          .catch((e) => {
            //check
            if (e.name === "PasswordException") {
              //set message string
              setFilesInfo((prevDictionary) => ({
                ...prevDictionary,
                [key]: {
                  ...filesInfo[key],
                  state: AppState.NONE,
                  message: "",
                  locked: true,
                  password: "",
                  name: selectedFile.name,
                  file: selectedFile, //selected file
                  size: selectedFile.size, //in bytes
                  number_pages_blob: null,
                  number_pages_size: 0,
                },
              }));
            } else {
              //set message string
              setFilesInfo((prevDictionary) => ({
                ...prevDictionary,
                [key]: {
                  ...filesInfo[key],
                  state: AppState.NONE,
                  message: "Can not load file. Something went wrong.",
                  locked: false,
                  password: "",
                  name: selectedFile.name,
                  file: selectedFile, //selected file
                  size: selectedFile.size, //in bytes
                  number_pages_blob: null,
                  number_pages_size: 0,
                },
              }));
            }
          });
      })
      .catch((e) => {
        console.log("Error: ", e);
      });
  };

  //reset screen
  //remove files info
  //empty selected files list
  const resetScreen = () => {
    //set flags
    setSelectedFiles([]);
    setShowEditFileScreen(false);
    setFilesInfo({});
    setStartProcessingFiles(false);
  };

  //on change padding
  const onChangePaddingValues = (e) => {
    //set padding
    setAdditionalSettings({
      ...additionalSettings,
      padding: {
        ...additionalSettings.padding,
        x:
          e.target.id === "paddingX"
            ? e.target.value
            : additionalSettings.padding.x,
        y:
          e.target.id === "paddingY"
            ? e.target.value
            : additionalSettings.padding.y,
      },
    });
  };

  //on change text color
  const onChangeTextColorValues = (color) => {
    //set
    setAdditionalSettings({
      ...additionalSettings,
      color: { ...additionalSettings.color, color: color },
    });
  };

  //on chnage size text
  const onChangeFontSizeText = (e) => {
    //set
    setAdditionalSettings({
      ...additionalSettings,
      font_size: Math.max(1, e.target.value),
    });
  };

  //on chnage checkbox values
  const onChangeCheckboxValues = (e) => {
    //set
    setAdditionalSettings({
      ...additionalSettings,
      start_from_zero: e.target.checked,
    });
  };

  //render password input modal
  const renderPassordInputModal = (item) => {
    return (
      <div
        className="modal fade"
        id="passwordInputModal"
        tabIndex="-1"
        aria-labelledby="passwordInputModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="passwordInputModalLabel">
                {item !== null ? item.name : "Failed loading file"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label htmlFor="password" className="col-form-label">
                    Unlock pdf to continue. Enter password below:
                  </label>
                  <input
                    type="password"
                    className="form-control mt-2"
                    id="password"
                    placeholder="Type password here..."
                    ref={passwordInputModalInputRef}
                  />
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={(e) => {
                  //clear reference value
                  passwordInputModalInputRef.current.value = null;
                }}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
                onClick={(e) => {
                  //process pdf file with password
                  processPDFFile(
                    item,
                    passwordInputModalInputRef.current.value,
                  );
                  //clear reference value
                  passwordInputModalInputRef.current.value = null;
                }}
              >
                Unlock
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  //render files list view
  const renderFilesListView = () =>
    //render
    selectedFiles.map((item, index) => (
      <div
        className="mt-3"
        data-bs-toggle={`${
          String(item.path) in filesInfo
            ? filesInfo[String(item.path)].locked
              ? "modal"
              : ""
            : ""
        }`}
        data-bs-target={`${
          String(item.path) in filesInfo
            ? filesInfo[String(item.path)].locked
              ? "#passwordInputModal"
              : ""
            : ""
        }`}
        key={index}
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          //check
          if (String(item.path) in filesInfo === true) {
            //if locked
            if (filesInfo[String(item.path)].locked === true) {
              //show password field
              //set item
              setSelectedItemForPasswordInput(item);
            } else {
              //set preview
              setShowPDFPreview({
                ...showPDFPreview,
                preview: true,
                file:
                  filesInfo[String(item.path)].number_pages_blob === null
                    ? filesInfo[String(item.path)].file
                    : filesInfo[String(item.path)].number_pages_blob,
                password: filesInfo[String(item.path)].password,
              });
            }
          }
        }}
      >
        {/* Flex container left image pdf right name and size */}
        <div className="position-relative d-flex bg-light border rounded-1 px-sm-3 px-2 py-4">
          {/* Left image */}
          <div className="ms-sm-3 ms-1 my-auto">
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ width: "80px", height: "80px" }}
            >
              {/* Image */}
              <img
                loading="lazy"
                src={
                  String(item.path) in filesInfo
                    ? filesInfo[String(item.path)].thumbnail != null
                      ? filesInfo[String(item.path)].thumbnail
                      : "./images/file_icon.png"
                    : "./images/file_icon.png"
                }
                alt="pdf_icon"
                style={{
                  width: "auto",
                  height: "auto",
                  maxWidth: "80px",
                  maxHeight: "80px",
                }}
              ></img>
            </div>
          </div>

          {/* Right name and size */}
          <div className="ms-3 my-auto d-none d-md-block d-sm-block me-5">
            <div className="px-2 fs-5 text-dark-subtle">{item.name}</div>
            <div className="d-flex">
              {/* File size */}
              <div className="px-2 fs-6 text-body-secondary">
                Size:{" "}
                {String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.PROCESSED
                    ? formatBytes(
                        filesInfo[String(item.path)].number_pages_size,
                      )
                    : formatBytes(item.size)
                  : formatBytes(0)}
              </div>
              {/* file type */}
              <div
                className={`px-2 ms-2 my-auto rounded-2 fw-bold ${
                  String(item.path) in filesInfo
                    ? filesInfo[String(item.path)].state === AppState.PROCESSED
                      ? "text-success"
                      : "bg-danger text-white"
                    : "bg-danger text-white"
                }`}
              >
                {String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.PROCESSED
                    ? "PROCESSED"
                    : getFileExtension(item.name.toUpperCase())
                  : getFileExtension(item.name.toUpperCase())}
              </div>
            </div>
            {/* Page Count */}
            <div className="px-2 fs-6 text-body-secondary">
              {String(item.path) in filesInfo
                ? (filesInfo[String(item.path)].pageCount === undefined
                    ? "__"
                    : filesInfo[String(item.path)].pageCount) + " Pages"
                : "0 Pages"}
            </div>
            {/* Lock Message */}
            <div
              className={`px-2 text-danger fs-6 mt-3 fw-bold ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].locked
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
            >
              Locked. Click to unlock.
            </div>
            {/* Warning */}
            <div
              className={`px-2 text-primary mt-3 text-lead ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].message !== ""
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
              style={{ fontSize: "16px" }}
            >
              {String(item.path) in filesInfo
                ? filesInfo[String(item.path)].message
                : ""}
            </div>
          </div>

          {/* Right side views spinner, download and delete buttons */}
          {/* Download Button */}
          {/* Show download button after processed */}
          <div
            className="position-absolute  justify-content-center align-items-center text-center my-auto"
            style={{ right: "0px", top: "50%", transform: "translateY(-50%)" }}
          >
            {" "}
            <div
              className={`my-auto me-2 ms-1 ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.PROCESSED
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
            >
              <button
                type="button"
                className="btn btn-outline-success"
                onClick={async (e) => {
                  //stop propagating
                  e.stopPropagation();
                  //check
                  if (String(item.path) in filesInfo === true) {
                    //blob
                    const blob = filesInfo[String(item.path)].number_pages_blob;
                    //save
                    await saveFile(blob, filesInfo[String(item.path)].name);
                  }
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-download"
                  viewBox="0 0 16 16"
                >
                  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                </svg>
              </button>
            </div>
            {/* Show spinner while processing */}
            {/* Spinner */}
            <div
              className={`spinner-border my-auto me-2 ms-1 ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.PROCESSING
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            {/* Delete Button */}
            {/* Show delete button after loaded */}
            <div
              className={`my-auto me-2 ms-1 ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.LOADED ||
                    filesInfo[String(item.path)].state === AppState.NONE
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
            >
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={(e) => {
                  //stop propagating
                  e.stopPropagation();
                  //remove file from selectedfiles list
                  setSelectedFiles(selectedFiles.filter((a) => a !== item));
                  //remove thumbnails
                  setFilesInfo((currentData) => {
                    // Destructure the key to remove into a throwaway variable (e.g., '_')
                    // and collect the rest of the properties into a new object 'rest'
                    const { [String(item.path)]: _, ...rest } = currentData;
                    //return
                    return rest;
                  });
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-trash"
                  viewBox="0 0 16 16"
                >
                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                  <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    ));

  return (
    //show hide loading view
    <div className="position-relative">
      {/* show pdf preview */}
      {/* page main content */}
      {showPDFPreview.preview ? (
        <PDFViewerView
          title={showPDFPreview.file === null ? "" : showPDFPreview.file.name}
          password={showPDFPreview.password}
          onClose={() => {
            //set preview
            setShowPDFPreview({
              ...showPDFPreview,
              preview: false,
              file: null,
              password: "",
            });
          }}
          file={showPDFPreview.file}
        ></PDFViewerView>
      ) : (
        <div>
          {/* Top bar */}
          <div className="bg-light border-bottom my-auto sticky-top">
            <div className="d-flex">
              <button
                type="button"
                className="btn btn-transparent"
                onClick={resetScreen}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  fill="#000000"
                  className="bi bi-arrow-clockwise"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                  />
                  <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                </svg>
              </button>
              {/* Title */}
              <label className="fs-3 ms-2 py-2 text-secondary fs-4">
                {props.title ?? "Add Page Numbers To PDF file"}
              </label>
            </div>
          </div>

          {/*Container left list & right controls */}
          <div
            className="d-flex"
            style={{
              height: "calc(100vh - 52px)",
              maxHeight: "calc(100vh - 52px)",
            }}
          >
            {/* Left List */}
            <div
              className="mt-md-5 mt-sm-3 mt-1 ms-sm-5 ms-1 mb-3"
              style={{ width: "75%", maxWidth: "75%", overflowY: "auto" }}
            >
              {renderFilesListView()}
            </div>

            {/* Right controls */}
            <div
              className="ms-sm-5 ms-1  border-start position-relative"
              style={{
                marginBottom: "100px", //add space to bottom for button, else overlap
                width: "25%",
                maxWidth: "25%",
                overflowY: "auto",
                minWidth: "200px",
              }}
            >
              {/* Page Number Text */}
              <div
                className="ms-4"
                style={{
                  width: "calc(100% - 48px)",
                }}
              >
                {/* Label */}
                <label
                  htmlFor="pagenumberText"
                  className="form-label mt-5 fs-4 text-dark"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Page number text properties."
                >
                  Font Properties:
                </label>

                {/* Font */}
                <div className="d-flex mt-2 my-auto text-center">
                  {/* Label */}
                  <label className="fs-6 me-2 text-secondary">Font:</label>
                  {/* Dropdown menu */}
                  <div className="dropdown">
                    <label
                      className="dropdown-toggle fs-6 text-primary"
                      type="text"
                      id="dropdownMenu"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        //show hide color picker
                        //turn other popups off
                        setAdditionalSettings({
                          ...additionalSettings,
                          font: {
                            ...additionalSettings.font,
                            popupShowing:
                              additionalSettings.font.popupShowing === true
                                ? false
                                : true,
                          },
                          position: {
                            ...additionalSettings.position,
                            popupShowing: false,
                          },
                          color: {
                            ...additionalSettings.color,
                            popupShowing: false,
                          },
                          opacity: {
                            ...additionalSettings.opacity,
                            popupShowing: false,
                          },
                        });
                      }}
                    >
                      {String(additionalSettings.font.font)}
                    </label>
                    <div
                      className={`dropdown-menu ${
                        additionalSettings.font.popupShowing === true
                          ? "show"
                          : ""
                      }`}
                      aria-labelledby="dropdownMenu"
                    >
                      {Object.values(StandardFonts).map((item, index) => (
                        <button
                          key={index}
                          className="dropdown-item"
                          type="button"
                          onClick={(e) => {
                            //show hide color picker
                            //turn other popups off
                            setAdditionalSettings({
                              ...additionalSettings,
                              font: {
                                ...additionalSettings.font,
                                font: item,
                                popupShowing:
                                  additionalSettings.font.popupShowing === true
                                    ? false
                                    : true,
                              },
                              position: {
                                ...additionalSettings.position,
                                popupShowing: false,
                              },
                              color: {
                                ...additionalSettings.color,
                                popupShowing: false,
                              },
                              opacity: {
                                ...additionalSettings.opacity,
                                popupShowing: false,
                              },
                            });
                          }}
                        >
                          {String(item)}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Font Size */}
                <div
                  className="d-flex mt-1 my-auto text-center"
                  style={{ height: "48px", maxHeight: "48px" }}
                >
                  {/* Label */}
                  <label className="fs-6 me-2 text-secondary py-3">
                    Font Size:
                  </label>
                  {/*Input */}
                  <input
                    type="number"
                    className="form-control mt-2 ms-2"
                    id="fontSize"
                    placeholder="Font size in px (20)"
                    onChange={onChangeFontSizeText}
                    value={additionalSettings.font_size}
                    style={{ width: "calc(100% - 88px)" }}
                  />
                </div>

                {/* Font Color */}
                <div className="d-flex mt-2 my-auto">
                  <div>
                    {/* Label */}
                    <label className="fs-6 me-2 text-secondary py-2">
                      Font Color:
                    </label>
                    {/* Show color value */}
                    <label
                      className={`text-center py-1 px-3 rounded-2 ${
                        additionalSettings.color.color !== "#ffffff"
                          ? "text-white"
                          : "text-dark"
                      }`}
                      style={{
                        backgroundColor: additionalSettings.color.color,
                      }}
                      onClick={(e) => {
                        //show hide color picker
                        //turn other popups off
                        setAdditionalSettings({
                          ...additionalSettings,
                          font: {
                            ...additionalSettings.font,
                            popupShowing: false,
                          },
                          position: {
                            ...additionalSettings.position,
                            popupShowing: false,
                          },
                          color: {
                            ...additionalSettings.color,
                            popupShowing:
                              additionalSettings.color.popupShowing === true
                                ? false
                                : true,
                          },
                          opacity: {
                            ...additionalSettings.opacity,
                            popupShowing: false,
                          },
                        });
                      }}
                    >
                      {additionalSettings.color.color}
                    </label>
                    {/* Color Picker */}
                    <HexColorPicker
                      className={`my-custom-picker mt-2 ${
                        additionalSettings.color.popupShowing === true
                          ? ""
                          : "d-none"
                      }`}
                      color={additionalSettings.color.color}
                      onChange={onChangeTextColorValues}
                    />
                  </div>
                </div>
              </div>

              {/* Additional settings */}
              <div
                className="ms-4 mt-4"
                style={{
                  width: "calc(100% - 48px)",
                }}
              >
                {/* Additional settings */}
                <div className="w-100 mt-4 border-top pt-3">
                  <label className="fs-4">Additional Settings:</label>
                </div>

                {/* Position */}
                <div className="d-flex mt-2 my-auto text-center">
                  {/* Label */}
                  <label className="fs-6 me-2 text-secondary">Position:</label>
                  {/* Dropdown menu */}
                  <div className="dropdown">
                    <label
                      className="dropdown-toggle fs-6 text-primary"
                      type="text"
                      id="dropdownMenu"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        //show hide color picker
                        //turn other popups off
                        setAdditionalSettings({
                          ...additionalSettings,
                          font: {
                            ...additionalSettings.font,
                            popupShowing: false,
                          },
                          position: {
                            ...additionalSettings.position,
                            popupShowing:
                              additionalSettings.position.popupShowing === true
                                ? false
                                : true,
                          },
                          color: {
                            ...additionalSettings.color,
                            popupShowing: false,
                          },
                          opacity: {
                            ...additionalSettings.opacity,
                            popupShowing: false,
                          },
                        });
                      }}
                    >
                      {String(additionalSettings.position.position)}
                    </label>
                    <div
                      className={`dropdown-menu ${
                        additionalSettings.position.popupShowing === true
                          ? "show"
                          : ""
                      }`}
                      aria-labelledby="dropdownMenu"
                    >
                      {Object.values(WatermarkPositions).map((item, index) => (
                        <button
                          key={index}
                          className="dropdown-item"
                          type="button"
                          onClick={(e) => {
                            //show hide color picker
                            //turn other popups off
                            setAdditionalSettings({
                              ...additionalSettings,
                              font: {
                                ...additionalSettings.font,
                                popupShowing: false,
                              },
                              position: {
                                ...additionalSettings.position,
                                position: item,
                                popupShowing:
                                  additionalSettings.position.popupShowing ===
                                  true
                                    ? false
                                    : true,
                              },
                              color: {
                                ...additionalSettings.color,
                                popupShowing: false,
                              },
                              opacity: {
                                ...additionalSettings.opacity,
                                popupShowing: false,
                              },
                            });
                          }}
                        >
                          {String(item)}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Opacity */}
                <div className="d-flex mt-1 my-auto text-center">
                  {/* Label */}
                  <label className="fs-6 me-2 text-secondary">Opacity:</label>
                  {/* Dropdown menu */}
                  <div className="dropdown">
                    <label
                      className="dropdown-toggle fs-6 text-primary"
                      type="text"
                      id="dropdownMenu"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        //show hide color picker
                        //turn other popups off
                        setAdditionalSettings({
                          ...additionalSettings,
                          font: {
                            ...additionalSettings.font,
                            popupShowing: false,
                          },
                          position: {
                            ...additionalSettings.position,
                            popupShowing: false,
                          },
                          color: {
                            ...additionalSettings.color,
                            popupShowing: false,
                          },
                          opacity: {
                            ...additionalSettings.opacity,
                            popupShowing:
                              additionalSettings.opacity.popupShowing === true
                                ? false
                                : true,
                          },
                        });
                      }}
                    >
                      {String(additionalSettings.opacity.opacity)}%
                    </label>
                    <div
                      className={`dropdown-menu ${
                        additionalSettings.opacity.popupShowing === true
                          ? "show"
                          : ""
                      }`}
                      aria-labelledby="dropdownMenu"
                    >
                      {[0, 5, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map(
                        (item, index) => (
                          <button
                            key={index}
                            className="dropdown-item"
                            type="button"
                            onClick={(e) => {
                              //show hide color picker
                              //turn other popups off
                              setAdditionalSettings({
                                ...additionalSettings,
                                font: {
                                  ...additionalSettings.font,
                                  popupShowing: false,
                                },
                                position: {
                                  ...additionalSettings.position,
                                  popupShowing: false,
                                },
                                color: {
                                  ...additionalSettings.color,
                                  popupShowing: false,
                                },
                                opacity: {
                                  ...additionalSettings.opacity,
                                  opacity: item,
                                  popupShowing:
                                    additionalSettings.opacity.popupShowing ===
                                    true
                                      ? false
                                      : true,
                                },
                              });
                            }}
                          >
                            {String(item)}%
                          </button>
                        ),
                      )}
                    </div>
                  </div>
                </div>

                {/* Checkbox Start from zero */}
                <div className="d-flex mt-1">
                  <label
                    className="form-check-label text-secondary"
                    htmlFor="start_from_zero"
                  >
                    Start From '0':
                  </label>
                  <input
                    className="ms-2 form-checkbox my-auto"
                    type="checkbox"
                    value=""
                    checked={additionalSettings.start_from_zero}
                    id="start_from_zero"
                    onChange={onChangeCheckboxValues}
                  />
                </div>

                {/* Padding */}
                <div className="mt-2">
                  {/* Label */}
                  <label className="fs-6 me-2 text-secondary my-auto">
                    Padding (x, y) in pixels:
                  </label>
                  <div className="d-flex mt-2 my-auto text-center">
                    {/* padding x */}
                    <div className="d-flex">
                      {/* X input */}
                      <input
                        className="form-control"
                        id="paddingX"
                        value={additionalSettings.padding.x}
                        placeholder="5px"
                        style={{ width: "80px" }}
                        type="number"
                        onChange={onChangePaddingValues}
                      />
                      {/* label , */}
                      <label className="ms-1">,</label>
                      {/* y input */}
                      <input
                        className="form-control ms-1"
                        id="paddingY"
                        value={additionalSettings.padding.y}
                        placeholder="5px"
                        style={{ width: "80px" }}
                        type="number"
                        onChange={onChangePaddingValues}
                      />
                    </div>
                  </div>

                  {/* note label padding */}
                  <label className="fs-6 text-success mt-2">
                    +ve padding x shifts Right and -ve padding x shifts Left
                    <br /> +ve padding y shifts Up and -ve padding y shifts Down
                  </label>
                </div>
              </div>

              {/* Convert Button */}
              <button
                className={`btn btn-danger py-2 py-sm-3 fs-4 position-fixed rounded-3 ${
                  isNumbering ? "disabled" : ""
                }`}
                style={{
                  marginLeft: "10px",
                  width:
                    window !== undefined
                      ? window.innerWidth * 0.25 < 200
                        ? "180px"
                        : window.innerWidth * 0.25 - 40
                      : "180px",
                  bottom: "10px",
                }}
                type="button"
                onClick={async (e) => {
                  //show hide color picker
                  //turn other popups off
                  setAdditionalSettings({
                    ...additionalSettings,
                    font: {
                      ...additionalSettings.font,
                      popupShowing: false,
                    },
                    position: {
                      ...additionalSettings.position,
                      popupShowing: false,
                    },
                    color: {
                      ...additionalSettings.color,
                      popupShowing: false,
                    },
                    opacity: {
                      ...additionalSettings.opacity,
                      popupShowing: false,
                    },
                  });
                  //set
                  setIsNumbering(true);
                  //loop
                  for (let i = 0; i < selectedFiles.length; i++) {
                    //selected file
                    const selectedFile = selectedFiles[i];
                    //key
                    const key = String(selectedFile.path);
                    //check
                    if (key in filesInfo === false) {
                      //continue
                      continue;
                    }

                    //doc info
                    const docInfo = filesInfo[key];

                    //lock unencrypted pdfs directly using pdf-lib
                    //for encrypted pdfs expract images then lock using pdf-lib
                    try {
                      //set state
                      setFilesInfo((prevDictionary) => ({
                        ...prevDictionary,
                        [key]: {
                          ...filesInfo[key],
                          state: AppState.PROCESSING,
                          message: `Reading file...`,
                        },
                      }));
                      //read pdf file
                      let data = await readPDFFileAsArrayBuffer(selectedFile);
                      // Load a PDF with form fields
                      //if encrypted
                      //proceed to ctch block
                      const pdfDoc = await PDFDocument.load(data);

                      //set
                      //set blob
                      setFilesInfo((prevDictionary) => ({
                        ...prevDictionary,
                        [key]: {
                          ...filesInfo[key],
                          state: AppState.PROCESSING,
                          message: `Numbering pages...`,
                        },
                      }));

                      //number pages
                      await addPageNumbersToPDF(
                        "Indexed PDF",
                        pdfDoc,
                        docInfo.password,
                        {
                          font: additionalSettings.font.font,
                          font_size: additionalSettings.font_size,
                          position: additionalSettings.position.position,
                          color: additionalSettings.color.color,
                          opacity: additionalSettings.opacity.opacity,
                          padding: {
                            x: Number(additionalSettings.padding.x),
                            y: Number(additionalSettings.padding.y),
                          },
                          start_from_zero: additionalSettings.start_from_zero,
                        },
                        (perct) => {
                          //set progress
                          setFilesInfo((prevDictionary) => ({
                            ...prevDictionary,
                            [key]: {
                              ...filesInfo[key],
                              state: AppState.PROCESSING,
                              message: `Numbering pages ${Math.floor(
                                perct * 100,
                              )}%...`,
                            },
                          }));
                        },
                        (blob) => {
                          //set
                          //set blob
                          setFilesInfo((prevDictionary) => ({
                            ...prevDictionary,
                            [key]: {
                              ...filesInfo[key],
                              state: AppState.PROCESSED,
                              message: `Successfully numbered pdf document pages. Click on download button to save.`,
                              number_pages_blob:
                                blob === null ? selectedFile : blob,
                              number_pages_size:
                                blob === null ? selectedFile.size : blob.size,
                            },
                          }));
                        },
                      );
                    } catch (e) {
                      //set state
                      setFilesInfo((prevDictionary) => ({
                        ...prevDictionary,
                        [key]: {
                          ...filesInfo[key],
                          state: AppState.PROCESSING,
                          message: `Reading file...`,
                        },
                      }));
                      //read pdf file
                      let data = await readEncryptedPDFFileAsArrayBuffer(
                        selectedFile,
                        docInfo.password,
                        (perct) => {
                          //set state
                          setFilesInfo((prevDictionary) => ({
                            ...prevDictionary,
                            [key]: {
                              ...filesInfo[key],
                              state: AppState.PROCESSING,
                              message: `Extracted ${Math.floor(perct * 100)}%`,
                            },
                          }));
                        },
                      );

                      //check
                      if (data === null) {
                        //set
                        //set blob
                        setFilesInfo((prevDictionary) => ({
                          ...prevDictionary,
                          [key]: {
                            ...filesInfo[key],
                            state: AppState.PROCESSED,
                            message: `Failed processing file.`,
                          },
                        }));
                        //cotinue
                        continue;
                      }
                      // Load a PDF with form fields
                      //if encrypted
                      //proceed to ctch block
                      const pdfDoc = await PDFDocument.load(data);

                      //set
                      //set blob
                      setFilesInfo((prevDictionary) => ({
                        ...prevDictionary,
                        [key]: {
                          ...filesInfo[key],
                          state: AppState.PROCESSING,
                          message: `Numbering pages...`,
                        },
                      }));

                      //number pages
                      await addPageNumbersToPDF(
                        "Indexed PDF",
                        pdfDoc,
                        docInfo.password,
                        {
                          font: additionalSettings.font.font,
                          font_size: additionalSettings.font_size,
                          position: additionalSettings.position.position,
                          color: additionalSettings.color.color,
                          opacity: additionalSettings.opacity.opacity,
                          padding: {
                            x: Number(additionalSettings.padding.x),
                            y: Number(additionalSettings.padding.y),
                          },
                          start_from_zero: additionalSettings.start_from_zero,
                        },
                        (perct) => {
                          //set progress
                          setFilesInfo((prevDictionary) => ({
                            ...prevDictionary,
                            [key]: {
                              ...filesInfo[key],
                              state: AppState.PROCESSING,
                              message: `Numbering pages ${Math.floor(
                                perct * 100,
                              )}%...`,
                            },
                          }));
                        },
                        (blob) => {
                          //set
                          //set blob
                          setFilesInfo((prevDictionary) => ({
                            ...prevDictionary,
                            [key]: {
                              ...filesInfo[key],
                              state: AppState.PROCESSED,
                              message: `Successfully numbered pdf document pages. Click on download button to save.`,
                              number_pages_blob:
                                blob === null ? selectedFile : blob,
                              number_pages_size:
                                blob === null ? selectedFile.size : blob.size,
                            },
                          }));
                        },
                      );
                    }
                  }
                  //reset
                  setIsNumbering(false);
                }}
              >
                Number Pages
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Password input modal */}
      {renderPassordInputModal(selectedItemForPasswordInput)}
    </div>
  );
}

export default NumberPDFPagesImagesListScreen;
